import { Box, Typography, useTheme } from "@mui/material";

const DomainTab = ({ array }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    array:{name:string}[]
}) => {
  const theme = useTheme();
  return (
    <Box
      id="domain-tab-container"
      data-testid="domain-tab-container"
      role="list"
      sx={ {
        display: "flex",
        gap: "0.5rem",
        marginTop: "2rem"
      } }
    >
      { array.map((el:{name:string},i:number) => {
        const slug = el.name.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "item";
        return (
          <Box
            key={ `${el.name}-${i}` }
            id={ `domain-tab-item-${slug}` }
            data-testid="domain-tab-item"
            role="listitem"
            aria-label={ el.name }
            sx={ {
              backgroundColor: theme.customColors.backgroundSecondaryHover,
              height: "1.5rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "0.25rem"
            } }
          >
            <Typography sx={ { padding:"0.125rem 0.5rem" } } fontSize={ "0.75rem" } fontWeight={ 600 } color={ theme.customColors.textPrimary }>
              { el.name }
            </Typography>
          </Box>
        );
      }) }

    </Box>
  );
};
export default DomainTab;
